/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useSize } from "../../../hooks/useSize";
import { useCultivo } from "../../../hooks/useCultivo";
import { useTipoEtiqueta } from "../../r_pedido_empaque/hooks/useTipoEtiqueta";
import { usePesoEnvase } from "../../r_pedido_empaque/hooks/usePesoEnvase";
import { useTipoCaja } from "../../r_pedido_empaque/hooks/useTipoCaja";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEtiqueta } from "../../r_pedido_empaque/hooks/useEtiqueta";
import { useBultosPalet } from "../../r_pedido_empaque/hooks/useBultosPalet";
import { useYeguere } from "../../r_pedido_empaque/hooks/useYeguere";
import { useDestinoInmediato } from "../../r_pedido_empaque/hooks/useDestinoInmediato";
import { useDestino } from "../../r_pedido_empaque/hooks/useDestino";
import { useTarimas } from "../../r_pedido_empaque/hooks/useTarimas";
import { TIPO_PEDIDO } from "../../r_pedido_empaque/constants/Empaque.Constants";
import { useVariedad } from "../hooks/useVariedad";
import { useColor } from "../hooks/useColor";

export const ProgramacionForm = ({
  values,
  errors,
  touched,
  setFieldValue,
  handleSubmit,
  handleChange,
  isLoading,
  onCancel,
}) => {
  const { getSize } = useSize();
  const { getCultivo } = useCultivo();
  const { tipoEtiqueta } = useTipoEtiqueta();
  const { tipoCaja, isTipoCajaLoading } = useTipoCaja(values.id_peso_envase);
  const { pesoEnvase } = usePesoEnvase(values.id_cultivo);
  const { etiquetas, isEtiquetaLoading } = useEtiqueta(
    values.id_tipo_caja,
    values.id_tipo_etiqueta
  );
  const { butlosPalet, isButosPaletsLoading } = useBultosPalet(
    values.id_tipo_caja
  );
  const { yeguere } = useYeguere();
  const { destinoInmediato } = useDestinoInmediato();
  const { destino } = useDestino();
  const { tarimas } = useTarimas();
  const { variedad, isVariedadLoading } = useVariedad(values.id_cultivo);
  const { color } = useColor();

  const [size, setSize] = useState([]);
  const [cultivoOptions, setCultivoOptions] = useState([]);
  const [isSizeLoading, setIsSizeLoading] = useState(false);

  const handleSizeChange = (calibre) => {
    setFieldValue("calibre", calibre);
    setFieldValue("id_tipo_etiqueta", 0);
    setFieldValue("id_peso_envase", 0);
    setFieldValue("id_tipo_caja", 0);
    setFieldValue("id_etiqueta", 0);
    setFieldValue("id_bultos", 0);
    setFieldValue("bultos", 0);
    setFieldValue("cantidad", 0);
  };

  const handleTipoEtiquetaChange = (id_tipo_etiqueta) => {
    setFieldValue("id_tipo_etiqueta", id_tipo_etiqueta);
    setFieldValue("id_peso_envase", 0);
    setFieldValue("id_tipo_caja", 0);
    setFieldValue("id_etiqueta", 0);
    setFieldValue("id_bultos", 0);
    setFieldValue("bultos", 0);
    setFieldValue("cantidad", 0);
  };

  const handlePesoEnvaseChange = (id_peso_envase) => {
    setFieldValue("id_peso_envase", id_peso_envase);
    setFieldValue("id_tipo_caja", 0);
    setFieldValue("id_etiqueta", 0);
    setFieldValue("id_bultos", 0);
    setFieldValue("bultos", 0);
    setFieldValue("cantidad", 0);
  };

  const handleTipoCajaChange = (id_tipo_caja) => {
    setFieldValue("id_tipo_caja", id_tipo_caja);
    setFieldValue("id_etiqueta", 0);
    setFieldValue("id_bultos", 0);
    setFieldValue("bultos", 0);
    setFieldValue("cantidad", 0);
  };

  const handleEtiquetaChange = (id_etiqueta) => {
    setFieldValue("id_etiqueta", id_etiqueta);
    setFieldValue("id_bultos", 0);
    setFieldValue("bultos", 0);
    setFieldValue("cantidad", 0);
  };

  const handleBultosPorPaletChange = (id_bultos, bultos) => {
    setFieldValue("id_bultos", id_bultos);
    setFieldValue("bultos", bultos);
    setFieldValue("cantidad", 0);
  };

  useEffect(() => {
    const getCultivoData = async () => {
      const response = await getCultivo();
      setCultivoOptions(response);
      if (response.length === 1) {
        setFieldValue("id_cultivo", response[0].idcultivo);
      }
    };
    getCultivoData();
  }, []);

  useEffect(() => {
    const getSizeOptions = async () => {
      setIsSizeLoading(true);
      try {
        const response = await getSize(values.id_cultivo);
        console.log(response);
        setSize(response);
      } catch (error) {
        console.error(error);
      } finally {
        setIsSizeLoading(false);
      }
    };
    if (values.id_cultivo !== 0) {
      getSizeOptions();
    }
  }, [values.id_cultivo]);

  return (
    <div>
      <div className="row">
        <label className="col-md-3 col-sm-12">
          <label>
            Cultivo{" "}
            <ErrorMessage
              errors={errors}
              touched={touched}
              field="id_cultivo"
              msg="Favor de seleccionar un cultivo"
            />
          </label>
          <select
            className="form-control"
            value={values.id_cultivo}
            onChange={handleChange}
            name="id_cultivo"
            disabled={cultivoOptions.length === 1}
          >
            <option>Seleccionar...</option>
            {cultivoOptions.map((item) => (
              <option value={item.idcultivo} key={item.idcultivo}>
                {item.cultivo}
              </option>
            ))}
          </select>
        </label>
        <label className="col-md-3 col-sm-12">
          <label>Fecha</label>
          <input
            value={values.fecha}
            onChange={handleChange}
            name="fecha"
            className="form-control"
            type="date"
            style={
              (errors.fecha && touched.fecha) !== undefined
                ? { borderColor: "red" }
                : {}
            }
          />
        </label>
        <label className="col-md-3 col-sm-12">
          <label>
            Variedad <Loading isLoading={isVariedadLoading} />
          </label>
          <select
            className="form-control"
            disabled={isVariedadLoading}
            value={values.id_variedad}
            onChange={handleChange}
            name="id_variedad"
            style={
              (errors.id_variedad && touched.id_variedad) !== undefined
                ? { borderColor: "red" }
                : {}
            }
          >
            <option value={0}>Seleccionar...</option>
            {variedad.map((item) => (
              <option key={item.idtipo} value={item.idtipo}>
                {item.tipo}
              </option>
            ))}
          </select>
        </label>
        <label className="col-md-3 col-sm-12">
          <label>Color</label>
          <select
            className="form-control"
            value={values.color}
            onChange={handleChange}
            name="color"
            style={
              (errors.color && touched.color) !== undefined
                ? { borderColor: "red" }
                : {}
            }
          >
            <option value={0}>Seleccionar...</option>
            {color.map((item) => (
              <option key={item.id} value={item.id}>
                {item.color}
              </option>
            ))}
          </select>
        </label>
      </div>
      <br />
      <div className="row">
        <div className="col-12 table-responsive">
          <label>
            Calibre <Loading isLoading={isSizeLoading} />{" "}
            <ErrorMessage
              errors={errors}
              touched={touched}
              field="calibre"
              msg="Favor de seleccionar un calibre"
            />
          </label>
          <hr />
          <table className="table">
            <thead>
              <tr>
                {size.map((item) => (
                  <th key={item.tamano}>
                    <button
                      className={`btn btn-outline-success ${
                        values.calibre === item.tamano && "active"
                      }`}
                      onClick={() => handleSizeChange(item.tamano)}
                      style={{ width: "100px", textAlign: "center" }}
                      disabled={isSizeLoading}
                    >
                      {item.tamano}
                    </button>
                  </th>
                ))}
              </tr>
            </thead>
          </table>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label>
            Tipo etiqueta{" "}
            <ErrorMessage
              errors={errors}
              touched={touched}
              field="id_tipo_etiqueta"
              msg="Favor de seleccionar una etiqueta"
            />
          </label>
          <hr />
          <div className="row">
            {values.calibre !== "" &&
              tipoEtiqueta.map((item) => (
                <div key={item.idtipo_etiqueta} className="d-grid col">
                  <button
                    className={`btn btn-outline-success ${
                      values.id_tipo_etiqueta === item.idtipo_etiqueta &&
                      "active"
                    }`}
                    onClick={() =>
                      handleTipoEtiquetaChange(item.idtipo_etiqueta)
                    }
                  >
                    {item.etiqueta}
                  </button>
                </div>
              ))}
          </div>
        </div>
        <div className="col-6">
          <label>
            Peso envase{" "}
            <ErrorMessage
              errors={errors}
              touched={touched}
              field="id_peso_envase"
              msg="Favor de seleccionar un peso"
            />
          </label>
          <hr />
          <div className="row">
            {values.id_tipo_etiqueta !== 0 &&
              pesoEnvase.map((item) => (
                <div
                  className="col d-grid mb-2"
                  md={3}
                  sm={2}
                  key={item.idtamano_envase}
                >
                  <button
                    className={`btn btn-outline-success ${
                      values.id_peso_envase === item.idtamano_envase && "active"
                    }`}
                    onClick={() => handlePesoEnvaseChange(item.idtamano_envase)}
                  >
                    {item.tamano}
                  </button>
                </div>
              ))}
          </div>
        </div>
      </div>
      <br />
      <br />
      <div className="row">
        <div className="col-6">
          <label>
            Tipo de caja <Loading isLoading={isTipoCajaLoading} />{" "}
            <ErrorMessage
              errors={errors}
              touched={touched}
              field="id_tipo_caja"
              msg="Favor de seleccionar un tipo de caja"
            />
          </label>
          <hr />
          <div className="row">
            {values.id_peso_envase !== 0 &&
              tipoCaja.map((item) => (
                <div
                  key={item.idenvase}
                  className="col-md-4 col-sm-12 d-grid mb-2"
                >
                  <button
                    className={`btn btn-outline-success ${
                      values.id_tipo_caja === item.idenvase && "active"
                    }`}
                    onClick={() => handleTipoCajaChange(item.idenvase)}
                    disabled={isTipoCajaLoading}
                  >
                    {item.envase}
                  </button>
                </div>
              ))}
          </div>
        </div>
        <div className="col-6">
          <label>
            Etiqueta <Loading isLoading={isEtiquetaLoading} />{" "}
            <ErrorMessage
              errors={errors}
              touched={touched}
              field="id_etiqueta"
              msg="Favor de seleccionar una etiqueta"
            />
          </label>
          <hr />
          <div className="row">
            {values.id_tipo_caja !== 0 &&
              etiquetas.map((item) => (
                <div
                  key={item.idrelacion}
                  className="col-md-4 col-sm-12 d-grid mb-2"
                >
                  <button
                    className={`btn btn-outline-success ${
                      values.id_etiqueta === item.idetiqueta && "active"
                    }`}
                    onClick={() => handleEtiquetaChange(item.idetiqueta)}
                    disabled={isEtiquetaLoading}
                  >
                    {item.etiqueta}
                  </button>
                </div>
              ))}
          </div>
        </div>
      </div>
      <br />
      <br />
      <div className="row">
        <div className="col-6">
          <label>
            Bultos por palet <Loading isLoading={isButosPaletsLoading} />{" "}
            <ErrorMessage
              errors={errors}
              touched={touched}
              field="bultos"
              msg="Favor de seleccionar un bulto"
            />
          </label>
          <hr />
          <div className="row">
            {values.id_etiqueta !== 0 &&
              butlosPalet.map((item) => (
                <div
                  className="col-md-4 col-sm-12 d-grid mb-2"
                  key={item.id_palet}
                  onClick={() =>
                    handleBultosPorPaletChange(item.id_palet, item.palet)
                  }
                >
                  <button
                    className={`btn btn-outline-success ${
                      values.id_bultos === item.id_palet && "active"
                    }`}
                    onClick={() => {}}
                    disabled={isButosPaletsLoading}
                  >
                    {item.palet}
                  </button>
                </div>
              ))}
            {values.id_etiqueta !== 0 && (
              <div className="col-md-4 col-sm-12 d-grid mb-2">
                <button
                  className={`btn btn-outline-success ${
                    values.id_bultos === 0 && "active"
                  }`}
                  onClick={() => handleBultosPorPaletChange(0, 0)}
                >
                  Otro
                </button>
              </div>
            )}
          </div>
          {values.id_etiqueta !== 0 && values.id_bultos === 0 && (
            <div className="row">
              <div className="col">
                <input
                  className="form-control"
                  value={values.bultos}
                  onChange={handleChange}
                  name="bultos"
                />
              </div>
            </div>
          )}
        </div>
        <div className="col-6">
          <label>
            Cantidad palet{" "}
            <ErrorMessage
              errors={errors}
              touched={touched}
              field="cantidad"
              msg="Favor de ingresar una cantidad"
            />
          </label>
          <hr />
          <input
            className="form-control"
            type="number"
            onChange={handleChange}
            name="cantidad"
            value={values.cantidad}
          />
          <label>
            Total: {values.cantidad !== "" && values.cantidad * values.bultos}
          </label>
        </div>
      </div>
      <br />
      <br />
      <div className="row">
        <div className="col-6">
          <label>Yeguere</label>
          <hr />
          <div className="row">
            {yeguere.map((item) => (
              <div className="col d-grid" key={item.idyeguere}>
                <button
                  className={`btn btn-outline-success ${
                    values.id_yeguere === item.idyeguere && "active"
                  }`}
                  onClick={() => setFieldValue("id_yeguere", item.idyeguere)}
                >
                  {item.yeguere}
                </button>
              </div>
            ))}
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col-12">
              <label>Tipo de pedido</label>
              <hr />
              <div className="row">
                {TIPO_PEDIDO.map((item) => (
                  <div className="col d-grid" key={item.tipo}>
                    <button
                      className={`btn btn-outline-success ${
                        values.tipo === item.tipo && "active"
                      } `}
                      onClick={() => setFieldValue("tipo", item.tipo)}
                    >
                      {item.tipo}
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-12">
              <input
                className="form-check-input"
                type="checkbox"
                checked={values.prioridad}
                onChange={handleChange}
                name="prioridad"
              />{" "}
              <label className="form-check-label" htmlFor="flexCheckDefault">
                ¿Prioridad?
              </label>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-12">
              <label>Destino inmediato</label>
              <hr />
              <div className="row">
                {destinoInmediato.map((item) => (
                  <div
                    className="col-md-4 col-sm-12 d-grid"
                    key={item.id_destino}
                  >
                    <button
                      className={`btn btn-outline-success ${
                        values.id_destino_inmediato === item.id_destino &&
                        "active"
                      }`}
                      onClick={() =>
                        setFieldValue("id_destino_inmediato", item.id_destino)
                      }
                    >
                      {item.destino}
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="col-6">
          <label>Pais destino</label>
          <hr />
          <div className="row">
            {destino.map((item) => (
              <div
                className="col-md-6 col-sm-12 d-grid mb-2"
                key={item.iddestino}
              >
                <button
                  className={`btn btn-outline-success ${
                    values.id_destino === item.iddestino && "active"
                  }`}
                  onClick={() => setFieldValue("id_destino", item.iddestino)}
                >
                  {item.destino}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
      <br />
      <br />
      <div className="row">
        <div className="col-6">
          <label>Tarimas</label>
          <hr />
          <div className="row">
            {tarimas.map((item) => (
              <div key={item.idtarima} className="col d-grid">
                <button
                  className={`btn btn-outline-success ${
                    values.id_tarima === item.idtarima && "active"
                  }`}
                  onClick={() => setFieldValue("id_tarima", item.idtarima)}
                >
                  {item.tarima}
                </button>
              </div>
            ))}
          </div>
        </div>
        <div className="col-6">
          <label>Observaciones</label>
          <hr />
          <textarea
            className="form-control"
            rows="3"
            value={values.observaciones ?? ""}
            name="observaciones"
            onChange={handleChange}
          ></textarea>
          <br />
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={values.fumigar}
              onChange={handleChange}
              name="fumigar"
            />
            <label className="form-check-label" htmlFor="flexCheckDefault">
              ¿Fumigar?
            </label>
          </div>
        </div>
      </div>
      <br />
      <br />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 10,
          width: "100%",
        }}
      >
        <button className="btn btn-danger" type="button" onClick={onCancel}>
          Cancelar
        </button>{" "}
        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          type="submit"
          disabled={isLoading}
        >
          {isLoading ? <Loading isLoading={isLoading} /> : "Guardar"}
        </button>
      </div>
    </div>
  );
};

const Loading = ({ isLoading }) => {
  if (isLoading) {
    return <FontAwesomeIcon icon="fas fa-spinner" spin />;
  }
  return null;
};

const ErrorMessage = ({ field, msg, errors, touched }) => {
  if (errors[field] && touched[field]) {
    return <label style={{ color: "red" }}>{msg}</label>;
  }
  return null;
};
